export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome Bonus"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Try Your Luck!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You've Win"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spin the wheel and get test funds to explore all platform features."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["These funds are for testing."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dive in and experience all features."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spin"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim"])}
}